var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    _vm._l(_vm.dataSource, function (item, index) {
      return _c("div", { key: index }, [
        _c("div", { staticClass: "topic" }, [_vm._v(_vm._s(item.name))]),
        _c(
          "div",
          { staticClass: "select-area" },
          _vm._l(
            item.schoolEvaluationAnswerOptionsList,
            function (optItem, optIndex) {
              return _c(
                "a-radio-group",
                {
                  key: optIndex,
                  on: { change: _vm.onChange },
                  model: {
                    value: _vm.selectMode[index],
                    callback: function ($$v) {
                      _vm.$set(_vm.selectMode, index, $$v)
                    },
                    expression: "selectMode[index]",
                  },
                },
                [
                  _c(
                    "a-radio",
                    { attrs: { value: `${optItem.id},${optItem.score}` } },
                    [_vm._v(_vm._s(optItem.name))]
                  ),
                ],
                1
              )
            }
          ),
          1
        ),
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }